module.exports = __webpack_public_path__ + "media/images/main-forte-logo-5f198279.jpg";